export enum NoteType {
  Public = 'Public',
  Private = 'Private',
}
